/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { MenuConfigModel } from '../../../../core/models';

export const EnduranceMenu: MenuConfigModel = {
    menuTitle: 'endurance',
    menuSubTitle: '',
    menuItems: [
        {
            location: './overview',
            heading: 'system_overview',
            id: 'system-overview',
            iconLocation: 'loadbalancer/icons/overview',
            hidden: false
        },
        {
            location: './local-configuration',
            heading: 'loadbalancer_local_config',
            id: 'menu-local-config',
            iconLocation: 'loadbalancer/icons/local-config',
            hidden: true,
            children: [
                {
                    location: './local-configuration/sys-date-time',
                    heading: 'date_time_sys_title',
                    id: 'sys-date-time',
                    hidden: true
                },
                {
                    location: './local-configuration/user-interface',
                    heading: 'user_interface',
                    id: 'user-interface',
                    hidden: true
                },
                {
                    location: './local-configuration/phys-adv-conf',
                    heading: 'physical_adv_conf',
                    id: 'physical-adv-conf',
                    hidden: true
                },
                {
                    location: './local-configuration/snmp',
                    heading: 'view_config_snmp_conf',
                    id: 'snmp-config',
                    hidden: true
                },
                {
                    location: './local-configuration/licence',
                    heading: 'licence_key',
                    id: 'licence',
                    hidden: true
                },
                {
                    location: './local-configuration/execute',
                    heading: 'execute_shell_command',
                    id: 'execute',
                    hidden: true
                },
                {
                    location: './local-configuration/collectors',
                    heading: 'collectors',
                    isChild: true,
                    id: 'collectors',
                    hidden: true,
                    children: [
                        {
                            location: './local-configuration/collectors/prometheus',
                            heading: 'prometheus',
                            id: 'prometheus',
                            hidden: true
                        }
                    ]
                },
                {
                    location: './local-configuration/portal-management',
                    heading: 'portal_management',
                    id: 'portal-management',
                    hidden: true
                },
            ]
        },
        {
            location: './network',
            heading: 'loadbalancer_network',
            id: 'menu-network',
            iconLocation: 'shared/icons/network',
            hidden: true,
            children: [
                {
                    location: './network/interfaces',
                    heading: 'net_int_config',
                    id: 'net_inter_config',
                    hidden: true
                },
                {
                    location: './network/ip-groups',
                    heading: 'ip_groups_subnets',
                    id: 'ip-groups',
                    hidden: true
                },
                {
                    location: './network/static/ips',
                    heading: 'static_ip',
                    id: 'static-ips',
                    hidden: true
                },
                {
                    location: './network/floating/ips',
                    heading: 'floating_ips',
                    id: 'floating-ips',
                    hidden: true
                },
                {
                    location: './network/regions',
                    heading: 'regions',
                    id: 'regions',
                    hidden: true
                }
            ]
        },
        {
            location: './cluster-configuration',
            heading: 'loadbalancer_cluster_configuration',
            id: 'menu-cluster-configuration',
            iconLocation: 'loadbalancer/icons/cluster-config',
            hidden: true,
            children: [
                {
                    location: './cluster-configuration/manage-services',
                    heading: 'manage_services',
                    id: 'manage-services',
                    hidden: true
                },
                {
                    location: './cluster-configuration/manage-acls',
                    heading: 'manage_acl_rules',
                    id: 'manage-acl-rules',
                    hidden: true
                },
                {
                    location: './cluster-configuration/advanced-services',
                    heading: 'advanced_services',
                    id: 'advanced-services',
                    hidden: true,
                },
                {
                    location: './cluster-configuration/ssl-certificate',
                    heading: 'ssl_certificates',
                    id: 'ssl-certificates',
                    hidden: true
                },
                {
                    location: './cluster-configuration/cipher-lists',
                    heading: 'ssl_cipher_lists',
                    id: 'cipher-list',
                    hidden: true
                },
                {
                    location: './cluster-configuration/ha-config',
                    heading: 'ha_conf',
                    id: 'ha-config',
                    hidden: true
                },
                {
                    location: './cluster-configuration/pulse-config',
                    heading: 'pulse_ha_config',
                    id: 'pulse-ha-config',
                    hidden: true
                },
                // {
                //     location: './cluster-configuration/gslb',
                //     heading: 'gslb',
                //     id: 'gslb',
                //     hidden: true
                // },
                {
                    location: './cluster-configuration/healthchecks',
                    heading: 'health_checks',
                    id: 'health-checks',
                    hidden: true
                },
            ],
        },
        {
            location: './maintenance',
            heading: 'maintenance',
            id: 'menu-maintenance',
            iconLocation: 'loadbalancer/icons/maintenance',
            hidden: true,
            children: [
                {
                    location: './maintenance/backup-restore',
                    heading: 'backup_restore',
                    id: 'backup-restore',
                    hidden: true
                },
                {
                    location: './maintenance/services',
                    heading: 'services_restart',
                    id: 'restart-services',
                    hidden: true
                },
                {
                    location: './maintenance/software-update',
                    heading: 'system_update_software_update',
                    id: 'software-update',
                    hidden: true
                },
                {
                    location: './maintenance/fallback-pages',
                    heading: 'fallback_pages',
                    id: 'fallback-pages',
                    hidden: true
                },
                {
                    location: './maintenance/users/list',
                    heading: 'user_management',
                    id: 'user-management',
                    hidden: true
                }
            ]
        },
        {
            location: './view-configuration',
            heading: 'view_config',
            id: 'menu-view-configuration',
            iconLocation: 'loadbalancer/icons/view-config',
            hidden: true,
            children: []
        },
        // {
        //     location: './reports',
        //     heading: 'reports',
        //     id: 'menu-reports',
        //     iconLocation: 'loadbalancer/icons/reports',
        //     hidden: true,
        //     children: [
        //         {
        //             location: './reports/gslb',
        //             heading: 'gslb',
        //             isChild: true,
        //             id: 'gslb',
        //             hidden: true,
        //             children: [
        //                 {
        //                     location: './reports/gslb-reports/healthcheck',
        //                     heading: 'health_check',
        //                     id: 'gslb-health-check',
        //                     hidden: true
        //                 },
        //                 {
        //                     location: './reports/gslb-reports/distributionstate',
        //                     heading: 'reports_distribution_state',
        //                     id: 'gslb-distribution-state',
        //                     hidden: true
        //                 }
        //             ]
        //         },
        //     ]
        // },
        {
            location: './view-logs',
            heading: 'logs',
            id: 'menu-logs',
            iconLocation: 'loadbalancer/icons/logs',
            hidden: true,
            children: [
                {
                    location: './view-logs/load-balancer',
                    heading: 'load_balancer',
                    id: 'load-balancer',
                    hidden: true
                }
            ]
        },
        {
            location: './notifications',
            heading: 'notifications',
            id: 'menu-notifications',
            iconLocation: 'shared/icons/bell',
            hidden: true
        },
        {
            location: './support',
            heading: 'support',
            id: 'menu-support',
            iconLocation: 'shared/icons/support',
            hidden: true,
            children: [
                {
                    location: './support/download',
                    heading: 'support_technical_support_download',
                    id: 'support-download',
                    hidden: true
                },
                {
                    location: './support/contact-us',
                    heading: 'support_technical_contact_us',
                    id: 'support-contact',
                    hidden: true
                }
            ]
        }
    ]
};
